<template>
  <div :class="user.is_vessel === true ? 'mt-1' : ''">
    <div class="row no-gutters justify-content-between mb-1" v-if="$route.name !== 'VesselAuditHistory'">
      <div class="col-sm-auto flex-grow-0">
        <h3 class="mb-0 text-left">{{ loading === true ? '' : vessel.name? vessel.name  + ' AUDIT RECORD' : ''}}</h3>
      </div>
    </div>

    <div class="row no-gutters align-items-center justify-content-between">
      <div class="col-sm-auto pb-2 mr-2">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-sm-auto pb-2">
        <div class="input-group input-group-sm fa-w-4 float-right">
          <div class="input-group-prepend">
            <label class="input-group-text input-group-sm bg-white small border-0" for="rowCount"># of Row(s):</label>
          </div>
          <select class="form-control form-control-sm rounded-left" id="rowCount" v-model="filters.count">
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="10000">All</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row no-gutters justify-content-between mb-1 mt-3">
      <div class="col-sm-12" style="max-width: 100%; overflow-x: auto; max-height: 70vh">
        <table class="small e-tbl text-center">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th class="align-middle" style="width: 1em" scope="col">#</th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              AUDIT TYPE 1
            </th>
            <th></th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              AUDIT TYPE 2
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 120px">
              AUDIT TYPE 3
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              AUDIT DATE
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 170px">
              APPOINTMENT DATE
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              AUDIT PLACE
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 150px">
              AUDITOR(S)
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 120px">
              STATUS
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              INTERNAL AUDIT SCORE
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              NON CONFORMITIES
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              OBSERVATION
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 120px">
              EXTENSION
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              CREATED BY
            </th>
            <th class="align-middle" scope="col" style="position: relative; min-width: 200px">
              CREATED AT
            </th>
            <th class="align-middle" scope="col">
              ACTION
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <loading></loading>
            </td>
          </tr>
          <template v-else v-for="(audit_record, index) in finalVesselAuditRecord">
            <template v-for="(type, type_index) in getAuditTypeNotNull(audit_record)">
              <tr class="ia-vessel-list no-select" @mouseover="highlightData(index, true)" @mouseout="highlightData(index, false)" @dblclick="viewAuditRecord(audit_record)">
                <td :class="'list_' + index" v-if="type_index === 0" :rowspan="getAuditTypeNotNull(audit_record).length">{{ index + 1 }}</td>
                <td :class="'list_' + index" class="text-uppercase" v-if="type_index === 0" :rowspan="getAuditTypeNotNull(audit_record).length">{{ getAuditTypeNotNull(audit_record).join(' & ')}}</td>
                <td :class="'list_' + index" class="text-uppercase">
                  {{ type }}
                </td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_2') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_2')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_2') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_2') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_2')).length"
                  :class="'list_' + index">{{ convertAuditType2IntoType(audit_record[type].audit_type_2) }}</td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_3') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_3')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_3') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_3') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_type_3')).length"
                  :class="'list_' + index"
                >
                  {{ convertAuditType3IntoType(audit_record[type].audit_type_3) }}
                </td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_start_end_date') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_start_end_date')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_start_end_date') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_start_end_date') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_start_end_date')).length"
                  :class="'list_' + index">
                  {{ audit_record[type].audit_date_start.human === audit_record[type].audit_date_end.human ? audit_record[type].audit_date_end.human : audit_record[type].audit_date_start.human + ' - ' + audit_record[type].audit_date_end.human }}
                </td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'appointment_date_picker') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'appointment_date_picker')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'appointment_date_picker') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'appointment_date_picker') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'appointment_date_picker')).length"
                  :class="'list_' + index">
                  {{ audit_record[type].appointment_date.human }}
                </td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_place') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_place')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_place') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_place') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_place')).length"
                  :class="'list_' + index"
                > {{ audit_record[type].audit_place }}</td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'auditor_ids') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'auditor_ids')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'auditor_ids') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'auditor_ids') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'auditor_ids')).length"
                  :class="'list_' + index"
                >
                  <div v-for="auditor in audit_record[type].auditors" class="text-left">
                    {{ auditor.name }} <strong>{{ (auditor.is_lead === true ? ' (Lead)' : '')}}</strong>
                  </div>
                </td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'report_status_id') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'report_status_id')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'report_status_id') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'report_status_id') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'report_status_id')).length"
                  :class="['bg-'+convertReportStatus(audit_record[type].report_status_id, true).color]">
                  {{ updated_report_status_names.filter(item => {
                  return item.id === audit_record[type].report_status_id
                })[0]?.name ?? 'APPOINTED' }}
                </td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_score') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_score')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_score') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_score') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'audit_score')).length"
                  :class="'list_' + index">{{ audit_record[type].audit_score }}</td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'ncr_count') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'ncr_count')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'ncr_count') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'ncr_count') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'ncr_count')).length"
                  :class="'list_' + index">{{ audit_record[type].ncr_count }}</td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'obs_count') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'obs_count')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'obs_count') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'obs_count') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'obs_count')).length"
                  :class="'list_' + index">{{ audit_record[type].obs_count }}</td>
                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'is_extended') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'is_extended')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'is_extended') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'is_extended') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'is_extended')).length"
                  :class="'list_' + index">{{ audit_record[type].is_extended === 0 ? 'NO' : 'YES'}}</td>
                <td :class="'list_' + index" v-if="type_index === 0" :rowspan="getAuditTypeNotNull(audit_record).length">{{ audit_record?.created_by?.name }}</td>

                <td
                  v-if="
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'created_at') === true &&
                    getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'created_at')[type] === true) ||
                    (type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'created_at') === false)"
                  :rowspan="type in getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'created_at') === false ? 1 : Object.keys(getSameDataFromType(index, getAuditTypeNotNull(audit_record), audit_record, 'created_at')).length"
                  :class="'list_' + index">
                  {{ audit_record[type]?.formatted_created_at }}
                </td>
                <td :class="'list_' + index" v-if="type_index === 0" :rowspan="getAuditTypeNotNull(audit_record).length">
                  <div class="dropdown dropright">
                    <button
                      id="actionDropdown"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-sm btn-secondary force-white-all"
                      data-toggle="dropdown"
                    >
                      <font-awesome-icon icon="cogs"/>
                    </button>
                    <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                      <button class="dropdown-item text-secondary font-weight-bolder"
                              v-if="isAllowed('vessel-ia.appointments.audit-records.view')"
                              @click="viewAuditRecord(audit_record)">
                        <font-awesome-icon icon="eye"/>
                        View on New Tab
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {vueAppMixin} from "@/mixins/vueAppMixin";
import AppLoading from "@/components/elements/AppLoading";
import {GENERATE_AUDIT_VESSEL} from "@/services/ConstantService";
import axios from 'axios';
import _ from 'lodash';
import {AlertService} from "@/services/AlertService";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import ScheduleAudit from "@/components/modules/ia/vessel/ScheduleAudit.vue";
import loading from "@/components/elements/AppLoading.vue";
import AuditRecordMixin from "@/mixins/AuditRecordMixin";
import FilterLikeExcel from "@/components/common/FilterLikeExcel.vue";
import {GlobalService} from "@/services/GlobalService";


export default {

  mixins: [vueAppMixin,PaginationMixin, AuditRecordMixin],
  components: {loading, AppLoading, ScheduleAudit, FilterLikeExcel},

  name: 'VesselAuditHistory',
  data() {
    return {
      vesselID: null,
      filters: {
        page: 1,
        count: 30,
        query : '',
        vessel_id : this.$route.params.vessel_id
      },
      requestPayload : {
        filter : {},
        sort : '',
        page : 1,
        active: 1,
        search: '',
        query : '',
        count: 30,
        vessel_id : this.vesselId
      },
      allModuleFilterParams : [],
      loading : false,
      customParamForFilterLikeExcel : [
        {
          key : 'vessel_id',
          value : this.$route.params.vessel_id
        }
      ]
    }
  },
  methods: {

    setFilterParam(filterParam, dataLength) {
      const moduleFilterParamIndex = this.allModuleFilterParams.findIndex(item => item.column_name === filterParam.column_name);
      if (moduleFilterParamIndex === -1) {
        if (filterParam.direction === '' && filterParam.where_in.length === 0) {
          return;
        }
        this.allModuleFilterParams.push(filterParam);
      } else {
        if (filterParam.direction === '' && filterParam.where_in.length === dataLength) {
          this.allModuleFilterParams.splice(moduleFilterParamIndex, 1)
        } else {
          this.allModuleFilterParams[moduleFilterParamIndex] = filterParam;
        }
      }

      this.requestPayload.filter = {};
      this.allModuleFilterParams.forEach(item => {
        this.requestPayload.filter[item.column_name] = item.where_in;
      });

      const sortIndex = this.allModuleFilterParams.findIndex(item => item.direction !== '');
      if (sortIndex === -1) {
        this.filterAuditRecordList();
        return;
      }
      const filterParamWithSort = this.allModuleFilterParams[sortIndex];
      const sortSign = filterParamWithSort.direction === 'desc' ? '-' : '';
      this.requestPayload.sort = sortSign + filterParamWithSort.column_name;
      this.filterAuditRecordList();
    },
    highlightData(rowIndex, hover) {
      const allList = $('.list_' + rowIndex);
      for (let counter = 0; counter < allList.length; counter++) {
        if (hover === true) {
          $(allList[counter]).addClass('list-hover')
        } else {
          $(allList[counter]).removeClass('list-hover')
        }
      }
    },
    async viewAuditRecord(vesselAuditRecord) {
      const route = this.$router.resolve({
        name: 'AppointmentDetails',
        params: {
          id: vesselAuditRecord.id,
          vessel_id : vesselAuditRecord.vessel_id,
          type : this.getFirstLandingType(vesselAuditRecord)},
      })

      window.open(route.href, '_blank')

    },
    async filterAuditRecordList() {
      this.loading = true;
      await this.getVesselAuditRecordList(this.requestPayload);
      this.loading = false;
    },
    async deleteSelected(audit_type_id, audit_type) {
      if(await AlertService.confirmDeleteAlert('Delete ' + audit_type.toUpperCase() + ' Audit Record', 'Are you sure you want to delete this Audit Record?', 'Delete')){
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (inputValue)=> {
            let response = await this.deleteAuditRecord({audit_type_id: audit_type_id, audit_type : audit_type, password: inputValue});
            if (typeof response === 'boolean' && response) {
              return response;
            } else {
              if (response.hasOwnProperty('message') && !response.hasOwnProperty('errors')) {
                swal.showValidationMessage(response.message);
              }
              else{
                swal.showValidationMessage(response.errors.password.join(','));
              }
            }
          }
        })
          .then(async (result)=>{
            if(result.isConfirmed){
              await this.successAlert('AUDIT RECORD DELETED SUCCESSFULLY','DELETE AUDIT RECORD');
              await this.filterAuditRecordList();
            }
          });
      }
    },
    async setPage(page) {
      this.pagination.currentPage = page;
      this.requestPayload.page = this.pagination.currentPage
      await this.getVesselAuditRecordList(this.requestPayload);
    },
  },
  async created() {
    this.requestPayload.vessel_id = this.vesselId
    this.searchAuditRecord = _.debounce(this.filterAuditRecordList, 750);
    await this.filterAuditRecordList();
    this.loading = true;
    await this.addRequestKeys([
      'getReportStatusKeys'
    ]);
    await this.generateRequestKeys({});

    await this.getVesselDetail(this.vesselId);
    this.loading = false;

  },
  watch : {
    async 'filters.count'(count) {
      this.requestPayload.count = count
      this.requestPayload.page = 1
      await this.filterAuditRecordList();
    },
    async 'filters.query'(query){
      this.requestPayload.query = query;
      this.searchAuditRecord();
    }
  },
  computed: {
    ...mapGetters([
      'updated_report_status_names'
    ]),
    vesselId(){
      return this.$route.name === 'VesselInternalAuditHistory' ? this.$route.params.id : this.$route.params.vessel_id
    },
    finalVesselAuditRecord() {
      return this.vesselAuditRecord.filter(item => {
        return item.sms !== null || item.isps !== null || item.cyber !== null;
      });
    }
  }
}
</script>

<style scoped lang="scss">
td {
  padding: 3px;
}
</style>
